export default "__VITE_ASSET__CWhhPh15__"